import React, { Component } from 'react';

class IconUpload extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="105.482" height="73.837" viewBox="0 0 105.482 73.837">
                <path id="Icon_awesome-cloud-upload-alt" data-name="Icon awesome-cloud-upload-alt" d="M88.6,34.323A15.841,15.841,0,0,0,73.837,12.8a15.742,15.742,0,0,0-8.785,2.67,26.373,26.373,0,0,0-49.23,13.152c0,.445.016.89.033,1.335a23.74,23.74,0,0,0,7.878,46.132H84.386A21.1,21.1,0,0,0,88.6,34.323ZM64.839,44.443H54.06V62.9a2.645,2.645,0,0,1-2.637,2.637H43.511A2.645,2.645,0,0,1,40.874,62.9V44.443H30.1a2.632,2.632,0,0,1-1.862-4.5L45.6,22.572a2.646,2.646,0,0,1,3.725,0L66.7,39.943A2.636,2.636,0,0,1,64.839,44.443Z" transform="translate(0 -2.25)" fill="#707070" opacity="0.2" />
            </svg>
        );
    }
}

export default IconUpload;